import { render } from "./EmployeeScreeningService.vue?vue&type=template&id=d7b90158&scoped=true"
import script from "./EmployeeScreeningService.vue?vue&type=script&lang=js"
export * from "./EmployeeScreeningService.vue?vue&type=script&lang=js"

import "./EmployeeScreeningService.vue?vue&type=style&index=0&id=d7b90158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b90158"]])

export default __exports__